// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useLedgerEnd } from '../ledger/useLedgerEnd';

const useHoldings: () => UseQueryResult<TemplateContract<Holding>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { operator } = useParties();
  return useQuery({
    queryKey: ['queryHoldings', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryHoldings(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useHoldings;
